export const MAX_OFFERS_IN_SET = 100
